export class Utils {
    public static toggleScroll(): void {
        const overlays: NodeListOf<HTMLElement> = document.querySelectorAll(`.overlay-modal`);
        if (!overlays) return;

        const documentWidth = document.documentElement.clientWidth;
        const windowWidth = window.innerWidth;
        const scrollbarWidth = windowWidth - documentWidth;

        if ((getComputedStyle(document.body).overflow === `hidden`)) {
            document.body.style.overflow = ``;
            overlays.forEach((overlay) => {
                overlay.style.paddingRight = `unset`;
            });
        } else {
            document.body.style.overflow = `hidden`;
            overlays.forEach((overlay) => {
                overlay.style.paddingRight = `${scrollbarWidth}px`;
            });
        }
    }

    public static removeClassByPrefix(element: HTMLElement, prefix: string): HTMLElement {
        const regx = new RegExp(`\\b${prefix}[^ ]*[ ]?\\b`, `g`);
        element.className = element.className.replace(regx, '');
        return element;
    }

    public static getCookie(name: string): string {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    public static setCookie(name: string, value: string | number, days?: number): void {
        let expires = ``;
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${value || ''}${expires}; path=/`;
    };

    public static toggleClass(element: HTMLElement, className: string): void {
        if (!element) return;
        element.classList.toggle(className);
    };

    public static removeClass(element: HTMLElement, className: string): void {
        if (!element) return;
        element.classList.remove(className);
    };

    public static addClass(element: HTMLElement, className: string): void {
        if (!element) return;
        element.classList.add(className);
    };

    public static getLang(): string {
        return document.documentElement.getAttribute(`lang`).toLowerCase();
    };

    public static escapeHTML(string: string): string {
        const entityMap: {[key: string]: string} = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            '/': '&#x2F;',
            '`': '&#x60;',
            '=': '&#x3D;'
        };
        return String(string).replace(/[&<>"'`=\/]/g, (s) => entityMap[s]);
    };

    public static copy(target: Element): Promise<void> {
        let
            selection = window.getSelection(),
            range = document.createRange(),
            text = ``;

        selection.removeAllRanges();
        range.selectNodeContents(target);
        selection.addRange(range);
        text = selection.toString();
        selection.removeAllRanges();

        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        } else {
            return Promise.reject(new Error("провал"));
        }
    }
}